import React from 'react';
import { useLocation } from "react-router-dom";
import { useOnTrekkerMount} from "utils/analytics";

const OnTrekkerMountEvent = React.memo(() => {
  useOnTrekkerMount((trekker) => {
    trekker.event('page');
  });
  return null;
});

export function TrackRouteChanges() {
  const { pathname } = useLocation();
  // will trigger page event on pathname change, but only once after mount and after trekker is loaded
  return <OnTrekkerMountEvent key={pathname} />
}
